<template>
  <b-row>
    <b-col>
      <Endereco v-model="pessoa_juridica.endereco" ref="endereco" />
    </b-col>
    <b-col>
      <Contatos v-model="pessoa_juridica.contatos" ref="contatos" />
    </b-col>
  </b-row>
</template>

<script>
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";

import { validationMixin } from "vuelidate";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  components: { Endereco, Contatos },
  data: () => ({}),
  validations: {},
  computed: {
    ...mapState("pessoas_juridica", ["pessoa_juridica"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.pessoa_juridica[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      return this.$refs.endereco.isValid();
    },
  },
  created() {},
};
</script>
